// extracted by mini-css-extract-plugin
export default {"container":"Summary__container--Nd9k-","header":"Summary__header--2SDe3","content":"Summary__content--MUqYk"};